export const QUERY_PARAM_PARSING_ERROR = 'incorrect syntax';
